"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagingDots = exports.getDotIndexes = exports.NextButton = exports.nextButtonDisabled = exports.PreviousButton = exports.prevButtonDisabled = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable complexity */
const react_1 = require("react");
const types_1 = require("./types");
const defaultButtonStyles = (disabled) => ({
    border: 0,
    background: 'rgba(0,0,0,0.4)',
    color: 'white',
    padding: 10,
    textTransform: 'uppercase',
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer',
});
const prevButtonDisabled = ({ currentSlide, wrapAround, cellAlign, slidesToShow, }) => {
    // inifite carousel
    if (wrapAround) {
        return false;
    }
    // disable if displaying the leftmost slide
    if (currentSlide === 0) {
        return true;
    }
    // remainder scroll mode
    if (cellAlign === types_1.Alignment.Right && currentSlide <= slidesToShow - 1) {
        return true;
    }
    return false;
};
exports.prevButtonDisabled = prevButtonDisabled;
const PreviousButton = (props) => {
    const handleClick = (event) => {
        event.preventDefault();
        props === null || props === void 0 ? void 0 : props.previousSlide();
    };
    const { prevButtonClassName, prevButtonStyle = {}, prevButtonText, } = props.defaultControlsConfig || {};
    const disabled = (0, exports.prevButtonDisabled)(props);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: prevButtonClassName, style: Object.assign(Object.assign({}, defaultButtonStyles(disabled)), prevButtonStyle), disabled: disabled, onClick: handleClick, "aria-label": "previous", type: "button" }, { children: prevButtonText || 'Prev' })));
};
exports.PreviousButton = PreviousButton;
const nextButtonDisabled = ({ currentSlide, slideCount, slidesToShow, wrapAround, cellAlign, }) => {
    // inifite carousel
    if (wrapAround) {
        return false;
    }
    // If we are at the last possible slide without wrap, disable
    if (currentSlide >= slideCount - 1) {
        return true;
    }
    // remainder scroll mode
    if (cellAlign === types_1.Alignment.Left &&
        currentSlide >= slideCount - slidesToShow) {
        return true;
    }
    return false;
};
exports.nextButtonDisabled = nextButtonDisabled;
const NextButton = (props) => {
    const handleClick = (event) => {
        event.preventDefault();
        props.nextSlide();
    };
    const { defaultControlsConfig } = props;
    const { nextButtonClassName, nextButtonStyle = {}, nextButtonText, } = defaultControlsConfig;
    const disabled = (0, exports.nextButtonDisabled)(props);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: nextButtonClassName, style: Object.assign(Object.assign({}, defaultButtonStyles(disabled)), nextButtonStyle), disabled: disabled, onClick: handleClick, "aria-label": "next", type: "button" }, { children: nextButtonText || 'Next' })));
};
exports.NextButton = NextButton;
/**
 * Calculate the indices that each dot will jump to when clicked
 */
const getDotIndexes = (slideCount, slidesToScroll, scrollMode, slidesToShow, wrapAround, cellAlign) => {
    const dotIndexes = [];
    const scrollSlides = slidesToScroll <= 0 ? 1 : slidesToScroll;
    if (wrapAround) {
        for (let i = 0; i < slideCount; i += scrollSlides) {
            dotIndexes.push(i);
        }
        return dotIndexes;
    }
    if (cellAlign === types_1.Alignment.Center) {
        for (let i = 0; i < slideCount - 1; i += scrollSlides) {
            dotIndexes.push(i);
        }
        if (slideCount > 0) {
            dotIndexes.push(slideCount - 1);
        }
        return dotIndexes;
    }
    if (cellAlign === types_1.Alignment.Left) {
        if (slidesToShow >= slideCount) {
            return [0];
        }
        const lastPossibleIndexWithoutWhitespace = slideCount - slidesToShow;
        for (let i = 0; i < lastPossibleIndexWithoutWhitespace; i += scrollSlides) {
            dotIndexes.push(i);
        }
        if (scrollMode === types_1.ScrollMode.remainder) {
            dotIndexes.push(lastPossibleIndexWithoutWhitespace);
        }
        else {
            dotIndexes.push(dotIndexes[dotIndexes.length - 1] + scrollSlides);
        }
        return dotIndexes;
    }
    if (cellAlign === types_1.Alignment.Right) {
        if (slidesToShow >= slideCount) {
            return [slideCount - 1];
        }
        const firstPossibleIndexWithoutWhitespace = slidesToShow - 1;
        if (scrollMode === types_1.ScrollMode.remainder) {
            for (let i = firstPossibleIndexWithoutWhitespace; i < slideCount - 1; i += scrollSlides) {
                dotIndexes.push(i);
            }
            dotIndexes.push(slideCount - 1);
        }
        else {
            for (let i = slideCount - 1; i > firstPossibleIndexWithoutWhitespace; i -= scrollSlides) {
                dotIndexes.push(i);
            }
            dotIndexes.push(dotIndexes[dotIndexes.length - 1] - scrollSlides);
            dotIndexes.reverse();
        }
        return dotIndexes;
    }
    // We should never reach this, because the if statements above cover all
    // possible values of cellAlign
    return dotIndexes;
};
exports.getDotIndexes = getDotIndexes;
const PagingDots = (props) => {
    const listStyles = {
        position: 'relative',
        top: -10,
        display: 'flex',
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    };
    const getButtonStyles = (0, react_1.useCallback)((active) => ({
        cursor: 'pointer',
        opacity: active ? 1 : 0.5,
        background: 'transparent',
        border: 'none',
        fill: 'black',
    }), []);
    const indexes = (0, exports.getDotIndexes)(props.slideCount, props.slidesToScroll, props.scrollMode, props.slidesToShow, props.wrapAround, props.cellAlign);
    const { pagingDotsContainerClassName, pagingDotsClassName, pagingDotsStyle = {}, } = props.defaultControlsConfig;
    return ((0, jsx_runtime_1.jsx)("ul", Object.assign({ className: pagingDotsContainerClassName, style: listStyles }, { children: indexes.map((index, i) => {
            let isActive = props.currentSlide === index ||
                props.currentSlide - props.slideCount === index ||
                props.currentSlide + props.slideCount === index;
            // the below condition checks and sets navigation dots active if the current slide falls in the current index range
            if (props.currentSlide < index && props.currentSlide > indexes[i - 1]) {
                isActive = true;
            }
            return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: isActive ? 'paging-item active' : 'paging-item' }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ className: pagingDotsClassName, type: "button", style: Object.assign(Object.assign({}, getButtonStyles(isActive)), pagingDotsStyle), onClick: props.goToSlide.bind(null, index), "aria-label": `slide ${index + 1} bullet`, "aria-selected": isActive }, { children: (0, jsx_runtime_1.jsx)("svg", Object.assign({ className: "paging-dot", width: "6", height: "6", "aria-hidden": "true", focusable: "false" }, { children: (0, jsx_runtime_1.jsx)("circle", { cx: "3", cy: "3", r: "3" }) })) })) }), index));
        }) })));
};
exports.PagingDots = PagingDots;
//# sourceMappingURL=default-controls.js.map